import { ActionType, getType } from 'typesafe-actions';

import * as Action from '../actions/DownloadAction';

const defaultState = {
  items: [],
};
export default function constant(
  state: DownloadState = defaultState,
  action: ActionType<typeof Action>
): DownloadState {
  switch (action.type) {
    case getType(Action.updateDownloadItems):
      return { items: [...state.items, ...action.payload] };
    case getType(Action.resetDownloadItems):
      return { items: [] };
    default:
      return state;
  }
}
